import type { LinkTokens } from './types';

export const link: LinkTokens = {
  colors: {
    default: {
      base: 'primary.50',
      hover: 'primary.90',
    },
    inline: {
      base: 'primary.50',
      hover: 'primary.90',
    },
    legal: {
      base: 'neutral.80',
      hover: 'neutral.90',
    },
    night: {
      base: 'neutral.0',
      hover: 'neutral.40',
    },
  },
};
